import { defineMessages } from 'react-intl'

const scope = `procurify.presenter.GetFinancialAccountPresenter`

export default defineMessages({
  fetchingFinancialAccountToastError: {
    id: `${scope}.fetchingFinancialAccountToastError`,
    defaultMessage: 'Financial account not found',
  },
})
